import React from "react";
import { Heart } from "lucide-react";


const LikeButton = ({ isLiked, totalLikes, onToggle, disabled }) => (
  <div className="inline-flex items-center gap-1">
    <button
      type="button"
      onClick={onToggle}
      disabled={disabled}
      title={isLiked ? "Unlike" : "Like"}
      className={`inline-flex items-center text-xs font-semibold disabled:opacity-60 disabled:cursor-not-allowed ${
        isLiked ? "text-danger" : "text-text_muted"
      }`}
    >
      <Heart size={15} className={isLiked ? "fill-current" : ""} />
    </button>
  </div>
);

export default LikeButton;
